// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LO QUE SE SUELTA DESDE EL ORDENADOR: LOS FICHEROS Y LAS CARPETAS ENTERAS (1-oct-2026, la Nube; t514, también la ficha)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Lo usan la Nube (pages/Nube.jsx · soltar) y la pestaña Archivos de la ficha (pages/Pacientes.jsx · TabArchivos): soltar
//  una carpeta del ordenador encima trae sus ficheros con su ruta, para recrear sus carpetas dentro.
//  t516 (27-oct) · el plan de esa carpeta (planDeCarpeta) vive aquí y no en utils/nubeSubidas: es puro, y la ficha lo
//  usa sin cargar el motor de subidas de la Nube, que habla con /api/nube.
import { motivoParaSaltar, CARPETAS_DEL_SISTEMA } from './nubeFormato'

// Los ficheros soltados, también los de dentro de una carpeta del ordenador: [{ file, ruta }] y si venía alguna carpeta.
// Las entradas se piden YA, dentro del evento: después de un await el navegador las invalida (como en pages/Nube.jsx).
export async function leerSoltado(dt) {
  const items = dt && dt.items ? [...dt.items].filter((i) => i.kind === 'file') : []
  const entradas = items.map((i) => (i.webkitGetAsEntry ? i.webkitGetAsEntry() : null)).filter(Boolean)
  if (!entradas.length) return { lista: [...((dt && dt.files) || [])].map((file) => ({ file })), esCarpeta: false }
  const lista = []
  let esCarpeta = false
  const recorrer = async (entrada) => {
    if (entrada.isFile) {
      const file = await new Promise((ok, ko) => entrada.file(ok, ko))
      lista.push({ file, ruta: String(entrada.fullPath || file.name).replace(/^\/+/, '') })
    } else if (entrada.isDirectory) {
      esCarpeta = true
      const lector = entrada.createReader()
      for (;;) {
        const lote = await new Promise((ok, ko) => lector.readEntries(ok, ko))
        if (!lote.length) break
        for (const x of lote) await recorrer(x)
      }
    }
  }
  for (const x of entradas) await recorrer(x)
  return { lista, esCarpeta }
}

const nfc = (s) => String(s == null ? '' : s).normalize('NFC')

// El plan de una carpeta soltada o elegida: [{ file, ruta }] con la ruta relativa ('Carpeta/Sub/a.pdf', separada por
// '/'). Devuelve las carpetas en orden de padre a hija, los archivos que se suben y los que se saltan con su motivo.
export function planDeCarpeta(entradas) {
  const carpetas = new Set()
  const archivos = []
  const saltados = []
  for (const e of entradas || []) {
    const ruta = nfc(e.ruta || (e.file && (e.file.webkitRelativePath || e.file.name)) || '').replace(/\\/g, '/').replace(/^\/+/, '')
    const partes = ruta.split('/').filter(Boolean)
    if (!partes.length) continue
    const nombre = partes[partes.length - 1]
    const dirs = partes.slice(0, -1)
    if (dirs.some((d) => CARPETAS_DEL_SISTEMA.includes(d.toLowerCase()))) { saltados.push({ ruta, motivo: 'sistema' }); continue }
    const motivo = motivoParaSaltar(nombre)
    if (motivo) { saltados.push({ ruta, motivo }); continue }
    for (let i = 1; i <= dirs.length; i++) carpetas.add(dirs.slice(0, i).join('/'))
    archivos.push({ file: e.file, ruta, carpeta: dirs.join('/'), nombre })
  }
  const orden = [...carpetas].sort((a, b) => (a.split('/').length - b.split('/').length) || (a < b ? -1 : a > b ? 1 : 0))
  return { carpetas: orden, archivos, saltados }
}
